import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from 'src/app/services/appointment.service';
import { ChangeDetectorRef } from '@angular/core';

declare var jQuery: any;
@Component({
  selector: 'app-diagnosticians',
  templateUrl: './diagnosticians.component.html',
  styleUrls: ['./diagnosticians.component.scss']
})

export class DiagnosticiansComponent implements OnInit {

  private isEqual(obj1: any, obj2: any): boolean {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }
  diagnosticiansList: any = [];
  user:any
  originalUserData: any;
 
  constructor(private formBuilder: FormBuilder,private router:Router,private appointmentService: AppointmentService, private spinner: NgxSpinnerService,private changeDetectorRef: ChangeDetectorRef,) { }
  location: any = null
  userType = 1002;
  userForm!: FormGroup;
  openModal: boolean=false;
  confPass: string = '';
  userOption: boolean = false;
  buttonText:any="Edit"
  successMessage: string = '';

 

  updateClient = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    mobileNo: new FormControl('', [Validators.required]),
    email: new FormControl('',  [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]),
    locationId: new FormControl('', [Validators.required]),
    username: new FormControl('', [Validators.required]),
    password: new FormControl(''),
    id: new FormControl(''),
    userOption:new FormControl('')
  });

  ngOnInit(): void {
    this.spinner.hide();
    this.spinner.show();
    const successMessage = localStorage.getItem('successMessage');
    if (successMessage) {
      this.successMessage = successMessage;
      localStorage.removeItem('successMessage');
  
      setTimeout(() => {
        this.successMessage = '';
      }, 3000);
    }
    this.appointmentService.getLocations().subscribe((res) => {
      this.location = res;
    });
    this.appointmentService
      .getUserAll(this.location, this.userType)
      .subscribe((res) => {
        this.diagnosticiansList = res.data;
        this.spinner.hide();

      });
  }

  createDiag(){
    this.router.navigate(
      ['/create-user'],
      { queryParams: { user: 'Diagnostician' } }
    );
      // this.router.navigateByUrl('/create-user', { state: {user:"diagnostician"} });

  }

  editForm(){
    if(this.buttonText=="Edit"){
      this.buttonText="Save";
      this.userForm.enable()
    }
    
    else{
      this.buttonText="Edit";
      this.userForm.disable()
    }
  }

  updateClientMethod(user:any) {
    this.originalUserData = { ...user };
    this.confPass='';
    this.userOption=user.userOption;
    this.updateClient.setValue({
      firstName: user.firstName || '',
      lastName: user.lastName || '',
      mobileNo: user.mobileNo || '',
      email: user.email || '',
      locationId: user.locationId || '',
      username: user.username || '',
      password: '',
      id: user.id,
      userOption:!user.userOption
    });

  }
  get f() { return this.updateClient.controls; }

    

  isFormChanged(): boolean {
    const currentData = this.updateClient.value;
    return Object.keys(currentData).some(key => {
      return !this.isEqual(currentData[key], this.originalUserData[key]);
    });
  }


    onClickSubmit() {
      console.log("changes"+this.isFormChanged());
      if (this.isFormChanged()) {
        this.spinner.show();
        this.appointmentService.updateUser(this.updateClient.value).subscribe(res => {
          localStorage.setItem('successMessage', 'Diagnostician details updated successfully.');
          jQuery("#editClientInfo").modal('hide');
          this.pageReload();
          this.spinner.hide();
        }, err => {
          // Handle error scenario
          this.successMessage = 'Error updating director details.';
          this.spinner.hide();
        });
      } else {
        // No changes were made in the form
        localStorage.setItem('successMessage', 'No changes were made.');
        jQuery("#editClientInfo").modal('hide');
        this.pageReload();
      }
    }

      pageReload() {
    location.reload()
  }

}
